import { VirtualListRef } from '@unistocks/components/virtual-list/list';
import Animated, { AnimatedRef } from 'react-native-reanimated';

/**
 * Safely scrolls the given ScrollView or FlashList to the top.
 * @param ref - The ref of the scrollable component to scroll.
 */
export const safeScrollToTop = (
  ref: AnimatedRef<Animated.ScrollView> | AnimatedRef<VirtualListRef<any>>
) => {
  const ScrollComponent = ref.current as any;

  if (!ScrollComponent) return;

  if ('scrollTo' in ScrollComponent) {
    ScrollComponent.scrollTo({ y: 0, animated: true });
  } else if ('scrollToTop' in ScrollComponent) {
    ScrollComponent.scrollToTop({ animated: true });
  } else if ('scrollToOffset' in ScrollComponent) {
    ScrollComponent.scrollToOffset({ offset: 0, animated: true });
  }
};
